module.exports = __webpack_public_path__ + "static/media/StabilityAI.6a2fef14.jpeg";